import { render } from "./DzxxwkLogin.vue?vue&type=template&id=7e52c849&ts=true"
import script from "./DzxxwkLogin.vue?vue&type=script&lang=ts"
export * from "./DzxxwkLogin.vue?vue&type=script&lang=ts"

import "./DzxxwkLogin.vue?vue&type=style&index=0&id=7e52c849&lang=less"

import exportComponent from "/builds/fe/keyan-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__